import ViewBase from "../../../view-base.view";
import { formats as FORMATS } from "../../../../config/constants";
import moment  from 'moment'

export default function StoreBaseTab() {
  ViewBase.call(this);

  let mapping = {};

  let onCheckboxChange = () => { };

  return {
    oninit: (vnode) => {
      if (vnode.attrs.mapping) {
        mapping = vnode.attrs.mapping;
      }
      if (vnode.attrs.onCheckboxChange) {
        onCheckboxChange = vnode.attrs.onCheckboxChange;
      }
    },
    view: (vnode) => {
      return m('.item.card.position-relative',
        m('.card-body',
          m('input.form-check-input.flex-shrink-0[type=checkbox].position-absolute', {
            checked: vnode.attrs.isSelected,
            onchange: (e) => {
              onCheckboxChange(mapping.storeCode, Boolean(e.target.checked))
            }
          }),
          m('.item-content',
            { style: { "margin-left": '24px' } },
            m('.item-content__top.d-flex.flex-row',
              // m('img.img-thumbnail', { src: mapping.photoString, alt: "fixture photo", style: { width: "60px", "margin-right": "14px" } }),
              m('div', [
                m('span.fw-bold', `[#${mapping.storeCode}] `, mapping.storeName),
                m('.tags', mapping.fixture.map((tag) => m('small.d-inline-flex.me-2.mt-2.px-2.py-1.fw-semibold.text-success-emphasis.bg-success-subtle.border.border-success-subtle.rounded-2', tag.fixtureName))),
              ])
            ),
            m('hr', { style: { "margin": '16px 0px', "background-color": "#e3e3e3" } }),
            m('.flex-grow-1.d-flex.flex-wrap.gap-4',
              m('label', { style: 'white-space: nowrap;' },
                m('.inline-label-with-point'),
                this.getText("LT00001079", "Created Date") + " : " + moment(mapping.createDate).format(FORMATS.ISO_DATE_FORMAT)
              ),
              m('label', { style: 'white-space: nowrap;' },
                m('.inline-label-with-point'),
                this.getText("LT00001080", "Updated Date") + " : " + moment(mapping.updateDate).format(FORMATS.ISO_DATE_FORMAT)
              ),
            )
          )
        )
      )
    }
  }
}
